import Color from "color";
import { darkenBy, lightenBy } from "./colors";

// todo: add color functions

class Theme {
  name = "";
  colors = {
    main: "#fff",
    second: "#111",
    third: "#ccc",
    primary: "#007bff",
    secondary: "#6c757d",
    success: "#28a745",
    danger: "#dc3545",
    warning: "#ffc107",
    info: "#17a2b8",
    light: "#f8f9fa",
    dark: "#343e40",
    muted: "#6c757d",
    white: "#fff",
    navActive: "#fff",

    boxShadow: Color("#000").alpha(0.25).rgb().string(),

    isLight: () => {
      return Color(this.colors.main).isLight();
    },

    shiftTone: (color, amount = 0.25) => {
      let col = Color(color);
      let shifted =
        amount > 0 ? lightenBy(col, amount) : darkenBy(col, Math.abs(amount));
      return shifted.hex();
    },

    shiftToneSame: (color, amount) => {
      let col = Color(color);
      let amt = Math.abs(amount);
      if (col.isDark()) {
        amt *= -1;
      }
      return this.colors.shiftTone(color, amt);
    },

    shiftToneOpposite: (color, amount) => {
      let col = Color(color);
      let amt = Math.abs(amount);
      if (col.isLight()) {
        amt *= -1;
      }
      return this.colors.shiftTone(color, amt);
    },

    navBgMain: () => this.colors.shiftToneOpposite(this.colors.main, 0.25),
    navBgSecond: () => this.colors.shiftToneOpposite(this.colors.main, 0.15),
    navColorSecond: () =>
      this.colors.shiftToneOpposite(this.colors.second, 0.15),
  };

  fonts = {
    main: {
      family: "Verdana, Arial, Helvetica, sans-serif;",
      size: "0.75rem",
    },
  };

  sizes = {
    pageWidth: "62rem",
  };

  constructor(name) {
    this.name = name;
  }
}

const main = new Theme("main");
main.colors.main =
  process.env.NODE_ENV === "development" ? "#0000f8" : "#0078f8";
main.colors.second = "#fff";
main.colors.third = "#0ca3f5";
main.colors.danger = "#F85898";
main.colors.navActive = "#30e3f1";

const dark = new Theme("dark");
dark.colors.main = "#222";
dark.colors.second = "#eee";
dark.colors.third = "#666";
dark.colors.boxShadow = Color("#000").alpha(0.3).rgb().string();

const light = new Theme("light");
light.fonts.main.family = "Times New Roman, serif";
light.fonts.main.size = "1rem";

export { main, dark, light };
